import reducer from 'state/direct-order-recurring/shipments/reducer';
import selectors from 'state/direct-order-recurring/shipments/selectors';
import actions from 'state/direct-order-recurring/shipments/actionCreators';
import effects from 'state/direct-order-recurring/shipments/effects';

export { selectors, actions, effects };

export default reducer;
